import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import API_URL from '../../common/url';
import Fetch from '../../common/Fetch';
import dictCache from '../../common/dictCache';
import RequestToDo from './RequestToDo';
import RequestAndReturnedSheet from './RequestAndReturnedSheet';
import RequestInfo from './RequestInfo';
import ClientDataSearch from './ClientDataSearch';
import ARSheet from './ARSheet';
import { saveParams, saveSearchParams } from '../../actions/noticeActions';
import { saveParams as saveProjectParams } from '../../actions/investigationActions';
import { genModules, genSubAuth } from './constants';
import './style.less';

const { TabPane } = Tabs;
const panes = [{
    title: '请款待办',
    key: 'requestToDo',
    component: RequestToDo,
}, {
    title: '请款和回款报表',
    key: 'requestAndReturnedSheet',
    component: RequestAndReturnedSheet,
}, {
    title: '客户数据查询',
    key: 'clientDataSearch',
    component: ClientDataSearch,
}, {
    title: 'AR表',
    key: 'arSheet',
    component: ARSheet,
}];

class RequestDataAnalysis extends Component {
    static childContextTypes = {
        clientHeight: PropTypes.number,
        businessList: PropTypes.array,
        notice: PropTypes.object,
    }

    constructor(props) {
        super(props);
        const { auth } = props;
        this.panes = genModules(panes, auth);
        const [{key: activeKey = ''}] = this.panes || [];
        this.state = {
            activeKey,
            businessList: [],
        };
    }

    componentDidMount() {
        this.queryWithLevelByParams();
    }

    getChildContext = () => {
        const { notice } = this.props;
        const { businessList } = this.state;
        const clientHeight = (document.body || document.documentElement).clientHeight;
        return {
            clientHeight,
            businessList,
            notice,
        };
    }

    // 请求业务线
    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, { typeName: 'LINE_OF_BUSINESS' })
                .then(cb)
                .catch(err => console.error(err));
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    getContent = ({ key, component }) => {
        const { auth } = this.props;
        const { activeKey } = this.state;
        if (key === activeKey) {
            const Content = component;
            return (
                <div className="tabWidth">
                    <Content auth={genSubAuth(auth, key)} />
                </div>
            );
        } else {
            return null;
        }
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }
    
    render() {
        const { activeKey } = this.state;
        return (
            <div className="requestDataAnalysis">
                <Tabs activeKey={activeKey} onChange={this.handleTabsChange}>
                    {this.panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{this.getContent(pane)}</TabPane>)}
                </Tabs>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        notice: {
            saveParams: (params) => dispatch(saveParams(params)),
            saveSearchParams: (params) => dispatch(saveSearchParams(params)),
            saveProjectParams: (params) => dispatch(saveProjectParams(params)),
        }
    };
};

export default connect(null, mapDispatchToProps)(RequestDataAnalysis);


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/index.js